var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 48,
    viewBox: "0 0 88 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96016 38.0009H14.8402L19.5602 19.4009L24.4402 38.0009H31.3202L39.1202 10.0009H33.0402L27.7602 30.4409L22.4402 10.0009H17.0402L11.5602 30.4409L6.40016 9.96094L0.160156 10.0009L7.96016 38.0009Z",
    fill: "#161D25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.503 38.2409C54.983 38.2409 58.543 35.0409 59.183 31.0409H53.623C53.143 32.9609 51.543 33.9609 49.263 33.9609C46.423 33.9609 44.543 32.2009 44.423 29.2809V29.0009H59.343C59.463 28.3609 59.503 27.6809 59.503 27.0809C59.423 21.0409 55.263 17.2009 49.103 17.2009C42.743 17.2009 38.543 21.3609 38.543 27.7609C38.543 34.1209 42.663 38.2409 49.503 38.2409ZM44.543 25.3209C44.863 22.8809 46.703 21.4009 49.143 21.4009C51.703 21.4009 53.423 22.8009 53.823 25.3209H44.543Z",
    fill: "#161D25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9452 33.2409C83.5051 33.2409 82.9452 32.6409 82.9452 31.2009V22.2009H87.6252V17.4409H82.9452V11.6809H77.3052V32.1209C77.3052 36.0409 79.2652 38.0009 83.1852 38.0009H87.8652V33.2409H84.9452ZM67.7052 17.4409H62.5852V38.0009H68.2252V27.9209C68.2252 24.8009 69.5051 22.5609 72.8652 22.5609H75.1052V17.4409H74.1452C70.9452 17.4409 69.3452 18.6809 68.2252 20.5209L67.7052 17.4409Z",
    fill: "#161D25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWert);
export default __webpack_public_path__ + "static/media/wert.55b223e125221e7e58865a91322d6a28.svg";
export { ForwardRef as ReactComponent };